var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGolinee(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.393,
    height: 54,
    viewBox: "0 0 38.393 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "blfrof95za"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 621",
    style: {
      fill: "none"
    },
    d: "M0 0h38.393v54H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 250"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 249",
    style: {
      clipPath: "url(#blfrof95za)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 400",
    d: "M35.909 27.927a17.479 17.479 0 1 1-17.48-17.48 17.481 17.481 0 0 1 17.48 17.48",
    transform: "translate(.611 6.72)",
    style: {
      fill: "#fff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 401",
    d: "M22.786 38.393a1.248 1.248 0 0 1-1.249-1.249v-3.12a1.25 1.25 0 1 1 2.5 0v3.12a1.248 1.248 0 0 1-1.249 1.249"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 402",
    d: "M27.155 36.52a1.248 1.248 0 0 1-1.249-1.249v-3.12a1.25 1.25 0 1 1 2.5 0v3.12a1.248 1.248 0 0 1-1.249 1.249"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 403",
    d: "M7.8 24.122c1.221 1.114 1.752 2.519 1.188 3.137s-2.011.219-3.232-.9S4 23.844 4.564 23.226s2.011-.219 3.232.9",
    transform: "translate(2.79 14.752)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 404",
    d: "M8.177 27.162C9.4 28.276 9.928 29.681 9.365 30.3s-2.013.219-3.232-.9-1.753-2.519-1.188-3.137 2.011-.219 3.232.9",
    transform: "translate(3.035 16.707)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 405",
    d: "M11.6 27.162c1.221 1.114 1.752 2.519 1.188 3.137s-2.013.219-3.232-.9-1.756-2.515-1.193-3.133 2.011-.219 3.232.9",
    transform: "translate(5.234 16.707)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 406",
    d: "M6.269 3.487 12.511 14.1l6.867-11.238A9.612 9.612 0 0 0 12.511.989c-3.745.624-6.242 1.249-6.242 2.5",
    transform: "translate(4.032 .572)",
    style: {
      fill: "#00dd4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 407",
    d: "M19.2 15.607c-.263 0-.519.028-.781.039v-.664c.026-.039.061-.069.084-.11l5.782-10.3a1.244 1.244 0 0 0 .112-.278 1.947 1.947 0 0 0 .256-.96C24.649.873 20.382 0 16.726 0S8.8.873 8.8 3.334a1.938 1.938 0 0 0 .258.958 1.254 1.254 0 0 0 .11.278l5.788 10.33a2.05 2.05 0 0 0 .338.434v.672a19.2 19.2 0 1 0 3.9-.4M16.726 2.5a12.827 12.827 0 0 1 5.1.836 12.818 12.818 0 0 1-5.1.838 12.808 12.808 0 0 1-5.094-.838 12.823 12.823 0 0 1 5.094-.836m-3.7 3.845a20.2 20.2 0 0 0 3.7.325 20.27 20.27 0 0 0 3.7-.324l-3.157 5.625a.624.624 0 0 1-1.089 0zM19.2 50.878a16.065 16.065 0 0 1-3.9-31.651v1.061a1.56 1.56 0 1 0 3.12 0v-1.521c.261-.012.518-.039.781-.039a16.075 16.075 0 1 1 0 32.151",
    style: {
      fill: "#1a1e27"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 408",
    d: "M25.167 44.329a3.6 3.6 0 0 1-1.29-.24 4.014 4.014 0 0 1-2.4-2.713 1.249 1.249 0 0 1 2.4-.682 1.552 1.552 0 0 0 .894 1.063 1.1 1.1 0 0 0 1.012-.11c.386-.245.751-.475.751-2a1.25 1.25 0 1 1 2.5 0c0 2.061-.554 3.25-1.913 4.11a3.649 3.649 0 0 1-1.949.572"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolinee);
export default __webpack_public_path__ + "static/media/golinee.b1d7ff78a9dc5d57242b1b57f5a83989.svg";
export { ForwardRef as ReactComponent };